import { combineReducers } from "@reduxjs/toolkit";
import {
  type FlightExchangeState,
  flightExchangeReducer,
} from "../features/exchange/store/reducer";
import { flightsPostBookingApi } from "../features/postbooking/store/api";
import flightPostBookingReducer, {
  type FlightPostBookingState,
} from "../features/postbooking/store/slice";
import flightSearchReducer, {
  type FlightSearchState,
} from "../features/search/store/slice";
import flightShopReducer, {
  type FlightsShopState,
} from "../features/shop/store/slice";

export interface FlightState {
  flights: {
    flightExchange: FlightExchangeState;
    flightPostBooking: FlightPostBookingState;
    flightSearch: FlightSearchState;
    flightShop: FlightsShopState;
  };
  flightsPostBooking: ReturnType<typeof flightsPostBookingApi.reducer>;
}

export const flightReducersMap = {
  flightExchange: flightExchangeReducer,
  flightPostBooking: flightPostBookingReducer,
  flightShop: flightShopReducer,
  flightSearch: flightSearchReducer,
};

export const flightRtkQueryReducers = {
  [flightsPostBookingApi.reducerPath]: flightsPostBookingApi.reducer,
};

export const flightsRootReducer = combineReducers(flightReducersMap);
